import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../style.module.scss"
import { FormattedMessage } from "react-intl";

const ProductGoodKnow = props =>{
    useStyles(classes);
    const {goodKnow} = props;

    return (
        <div className={`${classes.ProductGoodKnowContainer} ${classes.GolbalBorderTop}`}>
            <p className={classes.Hd}>
                <FormattedMessage id="good_to_know" defaultMessage="Good to know" />
            </p>

            <ul className={classes.Bd}>
                {
                    goodKnow?.map((item,index) =><li key={index}>
                        <span style={{
                            backgroundImage:`url(${item.icon})`
                        }}></span>
                        <span>{item.name}</span>
                    </li>)
                }
            </ul>
        </div>
    )
}

export default ProductGoodKnow;